"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9473],{

/***/ 69473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionAccordion": function() { return /* binding */ SectionAccordion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);




const SectionAccordion = (param)=>{
    let { title , actionLabel , action , faqs , spacing , topBorder  } = param;
    const isFaqsPresent = faqs && faqs.length > 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FaqSection, {
        type: spacing || "MEDIUM",
        topBorder: topBorder,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FaqSectionTitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSectionTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSectionAction, {
                        children: actionLabel !== null && action && (0,_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .isLinkAction */ .Gm)(action) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                            ...action,
                            appearance: "containedTransparent",
                            children: actionLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Accordion */ .UQ, {
                    children: isFaqsPresent && faqs.map((faq, index)=>{
                        if (!faq.question) return null;
                        // The first divider is only displayed if topBorder is false
                        const displayDivider = index !== 0 || !topBorder;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .AccordionItem */ .Qd, {
                            value: index.toString(),
                            isDivider: displayDivider,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .AccordionTrigger */ .o4, {
                                    children: faq.question
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .AccordionContent */ .vF, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .PortableText */ .YI, {
                                        value: faq.answer,
                                        appearance: "faq"
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
const FaqSection = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    paddingInline: 20,
    "@lg": {
        display: "grid",
        paddingInline: 30,
        maxWidth: "$maxWidthDesktop",
        marginInline: "auto",
        gridTemplateColumns: "1fr 1.5fr",
        gap: 30
    }
});
const FaqSectionTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    paddingBlockEnd: 56,
    projectFont: "heading04",
    color: "$white",
    "@lg": {
        paddingBlockEnd: 0,
        maxWidth: 430
    }
});
const FaqSectionAction = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "none",
    "@lg": {
        display: "block"
    }
});
const FaqSectionTitleWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 32,
    alignItems: "flex-start"
});
const AccordionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    "@lg": {
        gridColumn: 2,
        width: "100%",
        maxWidth: 1080
    }
});


/***/ })

}]);